import type { FC } from 'react';
import React from 'react';
import { css } from '@compiled/react';

import { OnboardingTakeover } from '../../Onboarding/OnboardingTakeover.tsx';
import type { OnboardingTakeoverType } from '@confluence/experiment-home-onboarding-takeover-v2/entry-points/useOnboardingTakeoverType.ts';

const homeBannerContainerStyles = css({
	gridColumn: '1 / span 1',
	gridRow: '1 / span 1',
	display: 'contents',
});

interface HomeBannerContainerProps {
	onboardingTakeoverType: OnboardingTakeoverType | null;
	isTemplatesCollectionEligible: boolean;
}

export const HomeBannerContainer: FC<HomeBannerContainerProps> = ({
	onboardingTakeoverType,
	isTemplatesCollectionEligible,
}) => {
	return (
		<div css={homeBannerContainerStyles}>
			<OnboardingTakeover
				onboardingTakeoverType={onboardingTakeoverType}
				isTemplatesCollectionEligible={isTemplatesCollectionEligible}
			/>
		</div>
	);
};
